export enum IndividualType {
  None = 0,
  Member,
  Spouse,
  Child,
  Pet,
}
